import React from 'react';
import { InstagramIcon, LinkedinIcon, FacebookIcon } from 'lucide-react';
import { Logo } from './Logo';
import { footerColumns } from '../data/content';
const socials = [{
  label: 'Instagram',
  Icon: InstagramIcon
}, {
  label: 'LinkedIn',
  Icon: LinkedinIcon
}, {
  label: 'Facebook',
  Icon: FacebookIcon
}];
export function Footer() {
  return <footer className="border-t border-slate-200/80 bg-white" data-id="element-21" data-mp="36ppn5toqoifo">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-20" data-id="element-22" data-mp="3ug3efhzi2d97">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,2fr)]" data-id="element-23" data-mp="38h3r5ed5aiu">
          <div data-id="element-24" data-mp="3lecaoioisghz">
            <Logo data-id="element-25" data-mp="3lelybzm3ebki" />
            <p className="mt-4 text-[11px] font-medium uppercase tracking-[0.18em] text-slate-500" data-id="element-26" data-mp="3ldalzbekzvhs">
              Soluciones digitales que impulsan tu crecimiento
            </p>
            <p className="mt-4 max-w-sm text-[15px] leading-relaxed text-ink-soft" data-id="element-27" data-mp="29ynmxp3fzdg4">
              Almaria es un estudio digital que diseña y desarrolla productos web escalables para
              empresas, profesionales y emprendedores.
            </p>
            <ul className="mt-7 flex items-center gap-3" data-id="element-28" data-mp="3l9shh1e8ymmw">
              {socials.map(({
              label,
              Icon
            }) => <li key={label} data-id="element-29" data-mp="3gck196cnssoa">
                  <a href="#contacto" aria-label={label} className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 text-ink-soft transition-all duration-200 hover:-translate-y-0.5 hover:border-accent hover:text-accent" data-id="element-30" data-mp="3v89cc9gb3le8">
                    <Icon className="h-4 w-4" strokeWidth={1.6} aria-hidden="true" data-id="element-31" data-mp="33e6nbb9yssq" />
                  </a>
                </li>)}
            </ul>
          </div>

          <div className="grid gap-8 sm:grid-cols-3" data-id="element-32" data-mp="ctgy372qzyoy">
            {footerColumns.map(column => <nav key={column.title} aria-label={column.title} data-id="element-33" data-mp="qsq9zujx86n4">
                <h3 className="text-[13px] font-semibold uppercase tracking-[0.14em] text-ink" data-id="element-34" data-mp="mrwr5flc5i13">
                  {column.title}
                </h3>
                <ul className="mt-4 space-y-3" data-id="element-35" data-mp="twfmxpvnlpqb">
                  {column.links.map(link => <li key={link} data-id="element-36" data-mp="yuzdk3l6zpp0">
                      <a href="#contacto" className="text-[15px] text-ink-soft transition-colors hover:text-accent" data-id="element-37" data-mp="yruz8de0jdkm">
                        {link}
                      </a>
                    </li>)}
                </ul>
              </nav>)}
          </div>
        </div>

        <div className="mt-14 border-t border-slate-200 pt-7" data-id="element-38" data-mp="1hj4buvj2yigf">
          <p className="text-sm text-slate-500" data-id="element-39" data-mp="1mjikofsi9wfi">
            © 2026 Almaria. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}